export class DialogHelper {
	/**
	 * Creates a confirm dialog and return if ok clicked.
	 * @param title Dialog title
	 * @param message Dialog message
	 * @return ok clicked result
	 */
	public static async confirmAsync(message: string, title: string) {
		return await Promise.resolve(DevExpress.ui.dialog.confirm(message, title));
	}

	/**
	 * Creates a confirm dialog and return if ok clicked
	 * @param elementText Text of the element to delete
	 */
	public static async deleteConfirmAsync(elementText: string = "das Element"): Promise<boolean> {
		return DialogHelper.confirmAsync(`Wollen Sie ${elementText} wirklich l&ouml;schen?`, `Löschen bestätigen`);
	}

	/**
	 * Creates a alert dialog.
	 * @param title Dialog title
	 * @param message Dialog message
	 */
	public static async alertAsync(message: string, title: string) {
		return await Promise.resolve(DevExpress.ui.dialog.alert(message, title));
	}
}